export default function formatTimeAgo(isoString: any) {
  const date = new Date(isoString);
  const now = new Date();
  
  // Ensure valid date
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date string provided');
  }

  // Calculate difference in milliseconds
  const diffMs = (now as any) - (date as any);
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  
  // Handle different time ranges
  if (diffDays === 0) {
    // Handle same-day cases
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    if (diffHours === 0) {
      const diffMinutes = Math.floor(diffMs / (1000 * 60));
      if (diffMinutes === 0) {
        return 'just now';
      }
      return `${diffMinutes} ${diffMinutes === 1 ? 'minute' : 'minutes'} ago`;
    }
    return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
  } else if (diffDays === 1) {
    return 'yesterday';
  } else if (diffDays < 30) {
    return `${diffDays} days ago`;
  } else if (diffDays < 365) {
    const months = Math.floor(diffDays / 30);
    return `${months} ${months === 1 ? 'month' : 'months'} ago`;
  } else {
    const years = Math.floor(diffDays / 365);
    return `${years} ${years === 1 ? 'year' : 'years'} ago`;
  }
};